(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9195],{

/***/ 7801:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(8996);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ PostLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var design_system_Section__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9336);
/* harmony import */ var design_system_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8204);




var PostLink = function(param) {
    var post = param.post, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/blog/".concat(post.slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(design_system_Section__WEBPACK_IMPORTED_MODULE_2__/* .Section */ .$0, {
                    as: "article",
                    mb: 2,
                    px: 1,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(design_system_Text__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                            as: "h3",
                            $textColor: "--yellow",
                            children: post.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(design_system_Text__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                                children: post.summary
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: children
                })
            ]
        })
    }, post.slug);
};


/***/ }),

/***/ 9336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ Section; },
/* harmony export */   "Hn": function() { return /* binding */ FullPage; },
/* harmony export */   "M$": function() { return /* binding */ SectionHeader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _styled_system_space__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4460);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 100vh;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Section = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-d8092968-0"
})(_templateObject(), (0,_styled_system_space__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh)({
    my: 3,
    px: 2
}), _styled_system_space__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
var SectionHeader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].header.withConfig */ .ZP.header.withConfig({
    componentId: "sc-d8092968-1"
})(_templateObject1(), (0,_styled_system_space__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh)({
    pt: 4
}), _styled_system_space__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
var FullPage = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(Section).withConfig({
    componentId: "sc-d8092968-2"
})(_templateObject2());


/***/ }),

/***/ 7945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ TextBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7379);
/* harmony import */ var design_system_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1821);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: sans-serif;\n  max-width: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var defaultMax = "55ch";
var TextBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(design_system_Box__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x).withConfig({
    componentId: "sc-c3ab26b1-0"
})(_templateObject(), function(param) {
    var _chars = param.chars, chars = _chars === void 0 ? defaultMax : _chars;
    return chars;
});


/***/ }),

/***/ 8996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Blog": function() { return /* binding */ Blog; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./src/design-system/Global/theme.ts
var theme = __webpack_require__(2047);
;// CONCATENATED MODULE: ./src/design-system/Keyword.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n  font-weight: 400;\n  font-size: inherit;\n  color: ",
        ";\n  color: var(--lightGreen);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Keyword = styled_components_browser_esm/* default.b.withConfig */.ZP.b.withConfig({
    componentId: "sc-b5bf9f30-0"
})(_templateObject(), theme/* theme.lightGreen */.rS.lightGreen);

// EXTERNAL MODULE: ./src/design-system/Text.ts
var Text = __webpack_require__(8204);
// EXTERNAL MODULE: ./src/design-system/TextBox.ts
var TextBox = __webpack_require__(7945);
;// CONCATENATED MODULE: ./src/components/Blog/Intro.tsx




var BlogIntro = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextBox/* TextBox */.z, {
        chars: "85ch",
        mx: "auto",
        pt: [
            2,
            3,
            4
        ],
        px: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    as: "h1",
                    $fontSize: "2.5rem",
                    my: 4,
                    children: "Blog"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                mb: 2,
                $fontWeight: 300,
                children: "Here I publish my solutions to coding challenges, and things I learn on my day to day job."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                mb: 2,
                $fontWeight: 300,
                children: [
                    "I also publish on Medium. You can find me over there as",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        as: "a",
                        href: "https://medium.com/@icjoseph",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        $textColor: "--yellow",
                        $fontWeight: 400,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            children: "@icjoseph"
                        })
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                as: "h2",
                pt: 1,
                mt: 3,
                mb: 2,
                $fontSize: "1.8rem",
                children: "Coding Challenges"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                mb: 2,
                $fontWeight: 300,
                children: [
                    "I put time into coding competitons and coding challengens. I focus mostly on ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Keyword, {
                        children: "Hash Code"
                    }),
                    ", ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Keyword, {
                        children: "Code Jam"
                    }),
                    ",",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Keyword, {
                        children: "Kick Start"
                    }),
                    ", and ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Keyword, {
                        children: "Advent of Code"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                mb: 2,
                $fontWeight: 300,
                children: "When solving coding challenges, I use the Rust programming language."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                as: "h2",
                pt: 1,
                mt: 3,
                mb: 2,
                $fontSize: "1.8rem",
                children: "Lessons Learned"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                mb: 2,
                $fontWeight: 300,
                children: [
                    "In this blog, I take the opportunity to document, things I learn, or best practices to use when working with front end and back end frameworks, using ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Keyword, {
                        children: "JavaScript"
                    }),
                    ",",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Keyword, {
                        children: "TypeScript"
                    }),
                    ", and even ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Keyword, {
                        children: "Rust"
                    }),
                    "."
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Blog/PostLink.tsx
var PostLink = __webpack_require__(6537);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.esm.js
var index_esm = __webpack_require__(154);
;// CONCATENATED MODULE: ./src/components/Blog/Search.tsx




var useSearch = function(query) {
    return (0,index_esm/* default */.Z)(query, function(q) {
        return fetch("/api/search?q=".concat(encodeURIComponent(q))).then(function(res) {
            return res.json();
        });
    });
};
var Search = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(""), text /*, setText*/  = ref[0];
    var query = text.length > 2 ? text : "";
    var data = useSearch(query).data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: query ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: data === null || data === void 0 ? void 0 : data.hits.map(function(post) {
                var ref;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostLink/* PostLink */.s, {
                    post: post,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("em", {
                        children: [
                            "...",
                            (ref = post._formatted) === null || ref === void 0 ? void 0 : ref.content,
                            "..."
                        ]
                    })
                }, post.slug);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        })
    });
};

// EXTERNAL MODULE: ./src/design-system/Container.ts
var Container = __webpack_require__(8947);
// EXTERNAL MODULE: ./src/design-system/Section.ts
var Section = __webpack_require__(9336);
;// CONCATENATED MODULE: ./src/pages/blog/index.tsx








var VERCEL_URL = "https://".concat("icyjoseph-oimjwazil-icyjoseph.vercel.app");
var __N_SSG = true;
var Blog = function(param) {
    var posts = param.posts;
    var hasPosts = posts.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "icyJoseph | Blog",
                description: "Here I publish my solutions to coding challenges, and things I learn on my day to day job.",
                openGraph: {
                    url: VERCEL_URL,
                    title: "icyJoseph | Blog",
                    site_name: "icyJoseph",
                    description: "Here I publish my solutions to coding challenges, and things I learn on my day to day job.",
                    images: [
                        {
                            url: "".concat(VERCEL_URL, "/waves_background.png"),
                            width: 960,
                            height: 540,
                            alt: "icyJoseph wavy background",
                            type: "image/png"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogIntro, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                pt: 1,
                mt: 5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        as: "h2",
                        mb: 2,
                        $fontSize: "2.25rem",
                        px: 1,
                        children: "Posts"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {
                        children: hasPosts ? posts.map(function(post) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostLink/* PostLink */.s, {
                                post: post
                            }, post.slug);
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                            mb: 2,
                            px: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                children: "Nothing has been published yet."
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var blog = (Blog);


/***/ }),

/***/ 154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* unused harmony export immutable */
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(821);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var isFunction = function (v) { return typeof v == 'function'; };

var normalize = function (args) {
    return isFunction(args[1])
        ? [args[0], args[1], args[2] || {}]
        : [args[0], null, (args[1] === null ? args[2] : args[1]) || {}];
};

// Create a custom hook with a middleware
var withMiddleware = function (useSWR, middleware) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _a = normalize(args), key = _a[0], fn = _a[1], config = _a[2];
        var middlewares = (config.use || []).concat(middleware);
        return useSWR(key, fn, __assign(__assign({}, config), { use: middlewares }));
    };
};

var immutable = function (useSWRNext) { return function (key, fetcher, config) {
    // Always override all revalidate options.
    config.revalidateOnFocus = false;
    config.revalidateIfStale = false;
    config.revalidateOnReconnect = false;
    return useSWRNext(key, fetcher, config);
}; };
var index = withMiddleware(swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, immutable);




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5565,9774,2888,179], function() { return __webpack_exec__(7801); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);